<template>
  <div
    class="flex translate-y-0 scale-100 rotate-0 skew-x-0 skew-y-0 items-center gap-2 rounded-lg"
    style="padding: 3.2%; gap: 3.2%; background-color: #f5f5f5"
  >
    <component
      :is="getComponent"
      :title="props.title"
      :message="props.message"
      :image="props.image"
    />
  </div>
</template>

<script>
const pushTypes = {
  android: "android",
  ios: "ios",
};
</script>
<script setup>
import { computed } from "vue";
import RfRetentionPushContentAndroid from "./RfRetentionPushContentAndroid.vue";
import RfRetentionPushContentIos from "./RfRetentionPushContentIos.vue";

const props = defineProps({
  title: { type: String, default: "Title" },
  message: { type: String, default: "Message" },
  image: { type: String, default: "" },
  type: {
    type: String,
    default: pushTypes.android,
    validator: v => (pushTypes?.[v] ? true : false),
  },
});

const getComponent = computed(() =>
  props.type === pushTypes.android ? RfRetentionPushContentAndroid : RfRetentionPushContentIos,
);
</script>
